module.exports = __webpack_public_path__ + "0f7149769d6b4ee77b646ee5b90c005a.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/@blueprintjs/core/resources/icons/icons-20.ttf
// module id = 1817
// module chunks = 0